import * as XLSX from 'xlsx';

export const PARCEL_FREIGHT_EXPORT_COLUMNS = [
  { header: 'CARGO', key: 'cargo' },
  { header: 'LOADING', key: 'loadingPort' },
  { header: 'VOLUME', key: 'volume' },
  { header: 'ALD/ADD', key: 'aldAdd' },
  { header: 'DISCHARGED 1', key: 'discharged1' },
  { header: 'DISCHARGED 2', key: 'discharged2' },
  { header: 'DISCHARGED 3', key: 'discharged3' },
  { header: 'FREIGHT LUMPSUM (USD)', key: 'freightLumpsum' },
  { header: 'LAYTIME (HOURS)', key: 'laytime' },
  { header: 'DEMURRAGE PDPR (PER DAY PRO RATE)', key: 'demurrage' },
  { header: 'R2', key: 'r2' },
];

export const displayValue = value => {
  if (value === null || value === undefined || value === '') return '-';
  return value;
};

const isFobIncoterm = row =>
  String(row?.incoterm ?? '')
    .trim()
    .toUpperCase() === 'FOB';

const getDischargePort = (rows, portKey) => {
  for (const row of rows) {
    const value = row?.[portKey];
    if (value && value !== '-') {
      return displayValue(value);
    }
  }
  return '-';
};

const formatFobLoadingPort = row => {
  const parts = [row.incoterm, row.route, row.loadingPort]
    .map(value => {
      if (
        value === null ||
        value === undefined ||
        value === '' ||
        value === '-'
      ) {
        return '';
      }
      return String(value).trim();
    })
    .filter(Boolean);

  return parts.length ? parts.join(' ') : '-';
};

export const buildParcelFreightExportRows = (parcels = []) => {
  if (!parcels?.length) return [];

  return parcels.flatMap(parcel => {
    const cargoLabel = parcel.deliveryUnit || '-';
    const fobRows = (parcel.incotermRows ?? []).filter(isFobIncoterm);

    if (!fobRows.length) {
      return [];
    }

    return fobRows.map(row => {
      const allIncotermRows = parcel.incotermRows ?? [];
      const deliveryBasis = displayValue(row.deliveryBasis);

      return {
        cargo: cargoLabel,
        loadingPort: formatFobLoadingPort(row),
        volume: deliveryBasis === '-' ? '-' : `${deliveryBasis} MB`,
        aldAdd: displayValue(row.aldAdd1),
        discharged1: getDischargePort(allIncotermRows, 'port1'),
        discharged2: getDischargePort(allIncotermRows, 'port2'),
        discharged3: getDischargePort(allIncotermRows, 'port3'),
        freightLumpsum: 'Requested',
        laytime: 'Requested',
        demurrage: 'Requested',
        r2: 'Requested',
      };
    });
  });
};

export const downloadParcelFreightExcel = (
  rows,
  filename = 'Parcel_Request_Freight_Availability.xlsx',
  columns = PARCEL_FREIGHT_EXPORT_COLUMNS
) => {
  const headers = columns.map(column => column.header);
  const data = rows.map(row => columns.map(column => row[column.key]));

  const worksheet = XLSX.utils.aoa_to_sheet([headers, ...data]);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Parcel Freight');
  XLSX.writeFile(workbook, filename);
};

export const formatSubmittedDate = isoDate => {
  if (!isoDate) return '-';
  const date = new Date(isoDate);
  if (Number.isNaN(date.getTime())) return '-';
  return new Intl.DateTimeFormat('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  }).format(date);
};

export const getProcurementStatusConfig = status => {
  const statusCode =
    status === '' || status === null || status === undefined
      ? 0
      : Number(status);

  switch (statusCode) {
    case 1:
      return {
        label: 'Available',
        className: 'bg-success text-light',
      };
    case 0:
    default:
      return {
        label: 'Not Available',
        className: 'bg-info text-light',
      };
  }
};
